<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <!-- Left Panel: Requisition Info -->
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Requisition Info
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row>

                  <v-col cols="12">
                    <v-autocomplete
                      label="Production Delivery*"
                      v-model="production_delivery_master_id"
                      :items="getPrdDeliveryList"
                      item-title="code"
                      item-value="id"
                      density="compact"
                      variant="outlined"
                      clearable
                        hide-details
                      :error-messages="errors.production_delivery_master_id"
                      @update:model-value="changeSaleOrder" 
                      required
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-autocomplete
                      label="Warehouse*"
                      v-model="warehouse_id"
                      :items="warehouseList"
                      item-title="name"
                      item-value="id"
                      density="compact"
                      variant="outlined"
                      clearable
                        hide-details
                      :error-messages="errors.warehouse_id"
                      required
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-date-input
                      label="Receive Date*"
                      v-model="receive_date"
                      variant="outlined"
                      density="compact"
                      clearable
                      prepend-icon=""
                      hide-details
                      :error-messages="errors.receive_date"
                      required
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-textarea
                      label="Remarks"
                      v-model="remarks"
                      density="compact"
                      variant="outlined"
                      clearable
                      :error-messages="errors.remarks"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <!-- Right Panel: Requisition Details -->
        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Requisition Details
              </v-expansion-panel-title>
              <v-expansion-panel-text>
              <v-row class="pt-0">
                  <v-col cols="12">
                     
                    <v-table density="compact" :loading="loading" fixed-header class="table-dotted-border-bottom">
                      <thead>
                        <tr>
                          <th class="text-center" style="width: 5%">SL</th>
                          <th class="text-center" style="width: 10%">Code</th>
                          <th class="text-center" style="width: 10%">Lot No</th>
                          <th class="text-left" style="width: 25%">Product Name</th>
                          <th class="text-center" style="width: 10%">Unit</th>
                          <th class="text-left" style="width: 20%">Quantity</th>
                          <th class="text-left" style="width: 20%">Rate</th>
                          <th class="text-left" style="width: 20%">Sales Rate</th>
                          <th class="text-left" style="width: 20%">Total</th>
                          <th class="text-right" style="width: 5%">Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        <template v-for="(item, index) in cart" :key="index">
                          <!-- Main row -->
                          <tr style="cursor: pointer;">
                            <td class="text-center py-1">{{ index + 1 }}</td>
                            <td class="text-left py-1">{{ item.product_code }}</td>
                            <td class="text-left py-1">
                                <v-text-field 
                                    :reverse="false" 
                                    controlVariant="stacked" 
                                    style="width: 100px" 
                                    label="" 
                                    :hideInput="false" 
                                    :inset="false" 
                                    type="text" 
                                    density="compact" 
                                    variant="outlined" 
                                    bg-color="grey-lighten-4" 
                                    v-model="item.lot_no" 
                                    hide-details
                                    @click.stop > 
                                </v-text-field>
                            </td>
                            <td class="text-left py-1">{{ item.product_name }}</td>
                            <td class="text-center py-1">{{ item.unit_name }}</td>
                            <td class="text-left py-1"> 
                              <v-text-field 
                                :reverse="false" 
                                controlVariant="stacked" 
                                style="width: 80px" 
                                label="" 
                                :hideInput="false" 
                                :inset="false" 
                                :min="1" 
                                type="number" 
                                density="compact" 
                                variant="outlined" 
                                bg-color="grey-lighten-4" 
                                v-model="item.qty" 
                                hide-details :error="item.qty < 1" 
                                :error-messages="item.qty < 1 ? 'Quantity must be greater than 0' : ''"
                                @input="updateTotal(item)"
                                @click.stop > 
                              </v-text-field> 
                            </td>

                            <td class="text-left py-1"> 
                              <v-text-field 
                                :reverse="false" 
                                controlVariant="stacked" 
                                style="width: 80px" 
                                label="" 
                                :hideInput="false" 
                                :inset="false" 
                                :min="1" 
                                type="number" 
                                density="compact" 
                                variant="outlined" 
                                bg-color="grey-lighten-4" 
                                v-model="item.rate" 
                                hide-details :error="item.rate < 1" 
                                :error-messages="item.rate < 1 ? 'Price must be greater than 0' : ''"
                                @input="updateTotal(item)"
                                @click.stop > 
                              </v-text-field> 
                            </td>

                            <td class="text-left py-1"> 
                              <v-text-field 
                                :reverse="false" 
                                controlVariant="stacked" 
                                style="width: 80px" 
                                label="" 
                                :hideInput="false" 
                                :inset="false" 
                                :min="1" 
                                type="number" 
                                density="compact" 
                                variant="outlined" 
                                bg-color="grey-lighten-4" 
                                v-model="item.sales_rate" 
                                hide-details :error="item.sales_rate < 1" 
                                :error-messages="item.sales_rate < 1 ? 'Sales Price must be greater than 0' : ''"
                                @click.stop > 
                              </v-text-field> 
                            </td>

                                                        <td class="text-left py-1"> 
                              <v-text-field 
                                :reverse="false" 
                                controlVariant="stacked" 
                                style="width: 80px" 
                                label="" 
                                :hideInput="false" 
                                :inset="false" 
                                :min="1" 
                                type="number" 
                                density="compact" 
                                variant="outlined" 
                                bg-color="grey-lighten-4" 
                                v-model="item.total" 
                                hide-details :error="item.total < 1" 
                                :error-messages="item.total < 1 ? 'Total must be greater than 0' : ''"
                                readonly="true"
                                @click.stop > 
                              </v-text-field> 
                            </td>

                            <td class="text-center py-1">
                              <v-btn icon color="red" variant="tonal" @click.stop="removeRow(index)">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </td>
                          </tr>

                        </template>

                        <tr v-if="cart.length === 0 && !loading">
                          <td colspan="6" class="text-center text-red">You have no item</td>
                        </tr>
                      </tbody>
                    </v-table>
                      
                  </v-col>
              </v-row>

                <v-divider class="my-2"></v-divider>

                <v-card-actions>
                  <v-row class="pt-2">
                    <v-col cols="8"></v-col>
                    <v-col cols="4" class="d-flex justify-end">
                      <v-btn
                        class="bg-grey-darken-1 me-2"
                        variant="flat"
                        :loading="loading"
                        @click="() => submitRequisition(0)"
                      >
                        Draft
                      </v-btn>
                      <v-btn
                        class="bg-primary"
                        variant="flat"
                        :loading="loading"
                        @click="() => submitRequisition(1)"
                      >
                        {{ isEdit ? "Update" : "Save" }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>
  import { ref, computed, onMounted, nextTick } from "vue";
  import { useStore } from "vuex";
  import { useField, useForm } from "vee-validate";
  import * as yup from "yup";
  import { toast } from "vue3-toastify";
  import { useRouter, useRoute } from "vue-router";

  const router = useRouter();
  const route = useRoute();
  const store = useStore();

  // UI state
  const panel = ref([0]);
  const panel2 = ref([0]);
  const loading = ref(false);
  const isEdit = ref(false);
  const requisitionId = ref(null);
  const cart = ref([]);
  const expandedRow = ref(null);

  // ================= VALIDATION =================
  const schema = yup.object({
    production_delivery_master_id: yup.number().nullable().when("type", {
      is: "sale_order",
      then: (schema) => schema.required("Sale Order required"),
    }),
    warehouse_id: yup.number().required("Warehouse required"),
    receive_date: yup.date().required("Delivery date required"),
    remarks: yup.string().nullable(),
  });

  // ================= FORM =================
  const { handleSubmit, setErrors, errors } = useForm({
    validationSchema: schema,
  });

  // ================= FIELDS =================
  const { value: type} = useField("type", null, { initialValue: "bulk",});
  const { value: production_delivery_master_id} = useField("production_delivery_master_id");
  const { value: warehouse_id} = useField("warehouse_id");
  const { value: receive_date} = useField("receive_date");
  const { value: remarks} = useField("remarks");
  const product_id = useField("product_id");
  const getPrdDeliveryList = ref([]);

  // ================= COMPUTED =================
  const isBulkRequisition = computed(() => type.value === "bulk");

  const getProductMapList = computed(() => store.getters.getProductMapList || []);


//   const getPrdDeliveryList = computed(
//     () => store.getters.getPrdDeliveryList || []
//   );
  const prdProductionList = computed(
    () => store.getters.getPrdProductionList || []
  );
  const warehouseList = computed(
    () => store.getters.getWarehouseList || []
  );

  // ================= METHODS =================

  function updateTotal(item) {
    item.total = (item.qty || 0) * (item.rate || 0);
 }

  function toggleRow(index) {
    expandedRow.value = expandedRow.value === index ? null : index;
  }

  function removeRow(index) {
    cart.value.splice(index, 1);
  }

  function changerequisitionType() {
    cart.value = [];
  }

  async function loadData() {
    if(store.getters.getProductMapList.length === 0) await store.dispatch("getProductMapList");
    if(store.getters.getWarehouseList.length === 0) await store.dispatch("getWarehouseList");
    await store.dispatch("getPrdDeliveryList", {is_receivable: true, });
  }

  // ================= SALE ORDER =================
  async function changeSaleOrder() {

   const production = getPrdDeliveryList.value.find(
      (p) => p.id == production_delivery_master_id.value
    );

    if (!production) return;

    cart.value = production.details.map((item) => ({
      product_id: item.product_id,
      product_name: item.product?.name,
      product_code: item.product?.code,
      unit_name: item.product?.unit?.name,
      qty: item.quantity,
      lot_no: "",
      rate: item.rate ?? 0,
      sales_rate: item.sales_rate ?? 0,
      total: (item.quantity || 0) * (item.rate || 0),
      template_items: item.raw_product_details,
    }));
  }

  // ================= PRODUCTION =================

  // ================= SUBMIT =================
  const submitRequisition = (status) => {
    handleSubmit(async () => {
      if (cart.value.length === 0) {
        toast.error("Cart is empty");
        return;
      }

      loading.value = true;

      const payload = {
        production_receive_master_id: isEdit.value ? requisitionId.value : null,
        type: type.value,
        production_delivery_master_id: production_delivery_master_id.value,
        warehouse_id: warehouse_id.value,
        receive_date: receive_date.value,
        remarks: remarks.value,
        status,
        cart: cart.value.map((i) => ({
          product_id: i.product_id,
          qty: i.qty,
          lot_no: i.lot_no,
          rate: i.rate ?? 0,
          sales_rate: i.sales_rate ?? 0,
          total: i.total ?? 0,
        })),
      };

      console.log("Payload:", payload);

      try {
        if (isEdit.value) {
          await store.dispatch("saveUpdateInvProductionReceive", payload);
          toast.success("Updated");
        } else {
          await store.dispatch("saveUpdateInvProductionReceive", payload);
          toast.success("Saved");
        }

        router.push({ name: "production-receive-records" });
      } catch (error) {
        let message = 'Something went wrong'; 
        if (error?.response?.data) { 
          const data = error.response.data; 
          if (data.errors) { 
            setErrors(error.response.data.errors); 
            message = Object.values(data.errors).flat().join('\n'); 
          } else if (data.message) { 
            message = data.message; 
          } 
        } else if (error.message) { 
          message = error.message; 
        } 
        toast.error(message);
      } finally {
        loading.value = false;
      }
    })();
  };

  // ================= EDIT =================
  async function loadDelivery(id) {
    const res = await store.dispatch("getInvProductionReceiveById", id);
    const data = res.data;

    getPrdDeliveryList.value = [data.production_delivery];
    type.value = data.type;
    production_delivery_master_id.value = data.production_delivery_master_id;
    warehouse_id.value = data.warehouse_id;
    receive_date.value = data.receive_date;
    remarks.value = data.remarks;

    cart.value = data.details.map((item) => ({
      product_id: item.product_id,
      product_name: item.product?.name,
      product_code: item.product?.code,
      unit_name: item.product?.unit?.name,
      qty: item.qty,
      lot_no: item.lot_no,
      rate: item.rate,
      sales_rate: item.sales_rate,
      total: (item.qty || 0) * (item.rate || 0),
      template_items: item.product?.template?.items,
    }));
  }

  // ================= INIT =================
  onMounted(async () => {
    store.commit("SET_LOADING", { color: "primary" });
    loading.value = true;
    await loadData();
    getPrdDeliveryList.value = store.getters.getPrdDeliveryList || [];
    if (route.query.id) {
      isEdit.value = true;
      requisitionId.value = route.query.id;
      await loadDelivery(requisitionId.value);
    }
    loading.value = false;
    store.commit("UNSET_LOADING");
  });
</script>